import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { TechnicalDifficultiesComponent } from './pages/technical-difficulties/technical-difficulties.component';
import { SsoComponent } from './pages/sso/sso.component';
import { CoreModule } from '../core/core.module';
import { MultiFactorAuthenticationComponent } from './pages/multi-factor-authentication/multi-factor-authentication.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { ForgotUsernameComponent } from './pages/forgot-username/forgot-username.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { SecurityQuestionsComponent } from '../component/security-questions/security-questions.component';

@NgModule({
  declarations: [
    TechnicalDifficultiesComponent,
    SsoComponent,
    MultiFactorAuthenticationComponent,
    LoginPageComponent,
    ForgotUsernameComponent,
    ForgotPasswordComponent,
    SecurityQuestionsComponent
  ],
  imports: [CommonModule, SharedModule, CoreModule],
  exports: [
    TechnicalDifficultiesComponent,
    SsoComponent,
    MultiFactorAuthenticationComponent,
    LoginPageComponent,
    ForgotUsernameComponent,
    ForgotPasswordComponent,
    SecurityQuestionsComponent
  ],
})
export class LoginModule {}
